import { render, staticRenderFns } from "./GiftMessagePreview.vue?vue&type=template&id=3e04f3c9"
import script from "./GiftMessagePreview.vue?vue&type=script&lang=js"
export * from "./GiftMessagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports